import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMentorshipProgramSurveyMutationVariables = Types.Exact<{
  object: Types.MentorshipSurvey_Insert_Input;
}>;


export type AddMentorshipProgramSurveyMutation = { __typename?: 'mutation_root', insert_mentorshipSurvey_one?: { __typename?: 'mentorshipSurvey', id: number, preSurveyEnabled: boolean, preSurveyLink?: string | null, preSurveyMentorRequired?: boolean | null, preSurveyMenteeRequired?: boolean | null, midSurveyEnabled: boolean, midSurveyLink?: string | null, midSurveyMentorRequired?: boolean | null, midSurveyMenteeRequired?: boolean | null, postSurveyEnabled: boolean, postSurveyLink?: string | null, postSurveyMentorRequired?: boolean | null, postSurveyMenteeRequired?: boolean | null } | null };


export const AddMentorshipProgramSurveyDocument = gql`
    mutation addMentorshipProgramSurvey($object: mentorshipSurvey_insert_input!) {
  insert_mentorshipSurvey_one(object: $object) {
    id
    preSurveyEnabled
    preSurveyLink
    preSurveyMentorRequired
    preSurveyMenteeRequired
    midSurveyEnabled
    midSurveyLink
    midSurveyMentorRequired
    midSurveyMenteeRequired
    postSurveyEnabled
    postSurveyLink
    postSurveyMentorRequired
    postSurveyMenteeRequired
  }
}
    `;
export type AddMentorshipProgramSurveyMutationFn = Apollo.MutationFunction<AddMentorshipProgramSurveyMutation, AddMentorshipProgramSurveyMutationVariables>;

/**
 * __useAddMentorshipProgramSurveyMutation__
 *
 * To run a mutation, you first call `useAddMentorshipProgramSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMentorshipProgramSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMentorshipProgramSurveyMutation, { data, loading, error }] = useAddMentorshipProgramSurveyMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddMentorshipProgramSurveyMutation(baseOptions?: Apollo.MutationHookOptions<AddMentorshipProgramSurveyMutation, AddMentorshipProgramSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMentorshipProgramSurveyMutation, AddMentorshipProgramSurveyMutationVariables>(AddMentorshipProgramSurveyDocument, options);
      }
export type AddMentorshipProgramSurveyMutationHookResult = ReturnType<typeof useAddMentorshipProgramSurveyMutation>;
export type AddMentorshipProgramSurveyMutationResult = Apollo.MutationResult<AddMentorshipProgramSurveyMutation>;
export type AddMentorshipProgramSurveyMutationOptions = Apollo.BaseMutationOptions<AddMentorshipProgramSurveyMutation, AddMentorshipProgramSurveyMutationVariables>;